import React from 'react'
import BackupCodes from '../components/common/templates/Login/BackupCodes';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Heading } from '../components/common/atoms';

export default function SettingsBackupCodesPage() {
  const location = useLocation()
  let codes = location.state?.backup_codes
  const codesHandler = () => {}

  return (
    <div>
      <div>
        <Heading mainHeading='Account Settings' subClasses='mt-1 text-sm text-gray-600' />
      </div>
      <div className='rounded-md shadow-md my-4 bg-white px-3 py-4' style={{ width: '32rem' }}>
        <BackupCodes codesHandler={codesHandler} back_codes={codes} login_button={false} />
      </div>
    </div>
  )
}
